import React, { useState, useEffect, useRef } from 'react'
import Select from "react-select";
// BasicPagination removed — using plain buttons to avoid stale closure issues
import CommanInput from '../Constent/CommanInput';
import CommanDropDown from '../Constent/CommanDropDown';
import { Button } from 'react-bootstrap';
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, EditorState, ContentState } from "draft-js";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { DELETS_WITH_TOKEN, GET_WITH_TOKEN } from '../../Backend/Bakend';
import { showToast, showErrorToast } from '../Constent/Toast';

const Package = () => {
    const API_BASE = "https://api.placestovisitindia.com";

    const emptyForm = {
        title: "",
        category_id: "",
        sub_category_id: "",
        duration: "",
        transportation: "",
        price: "",
        status: "1",
        type: "",
        itinerary: "",
        post_slug: "",
        package_category_id: "",
        slug: "",
        nights: "",
        days: "",
        price_unit: "",
        total_person: "",
        pickup_drop: "",
        meal_plan: "",
        accommodation: "",
        overview: EditorState.createEmpty(),
        inclusions: EditorState.createEmpty(),
        exclusions: EditorState.createEmpty(),
        travel_tips: EditorState.createEmpty(),
        brief_itinerary: EditorState.createEmpty(),
        highlights: EditorState.createEmpty(),
        terms_conditions: EditorState.createEmpty(),
        seo_content: EditorState.createEmpty(),
        featured_image: "",
        rating: "",
        package_headline_first: "",
        package_headline_second: "",
        title_one: "",
        images: [],
    };

    const [selectedPosts, setSelectedPosts] = useState([]);
    const [bookingData, setBookingData] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [IsEdit, setIsEdit] = useState(false);
    const [IsEditId, setIsEditId] = useState('');
    const [PostList, setPostList] = useState([]);
    const [Packlist, setPackage] = useState([]);
    const [CatId, setCatId] = useState('');
    const [subCatId, setSubCatId] = useState('');
    const [featuredImageFile, setFeaturedImageFile] = useState(null);
    const [featuredImagePreview, setFeaturedImagePreview] = useState("");
    const [itineraryFile, setItineraryFile] = useState(null);
    const [Data, setData] = useState(emptyForm);
    const [selectedName, setSelectedName] = useState([]);
    const [vecotorImage, setVecotorImage] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [packageList, setPackageList] = useState([]);
    const [errors, setErrors] = useState({});
    const [relatedPostList, setRelatedPostList] = useState([]);
    const [selectedPostIds, setSelectedPostIds] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [searchText, setSearchText] = useState("");
    const searchRef = useRef("");

    const AddNewQuestion = () => setQuestions((qs) => [...qs, { name: "", value: "" }]);
    const DeleteQuestion = (index) => setQuestions((qs) => qs.filter((_, i) => i !== index));

    // ✅ Refs always hold latest values — fixes stale closure in BasicPagination onChange
    const CatIdRef = useRef('');
    const subCatIdRef = useRef('');
    const currentPageRef = useRef(1);

    useEffect(() => {
        getCat();
        getPostShow123();
        getPackageCategory();
        getAllPostsForDropdown();
    }, []);

    const getAllPostsForDropdown = () => {
        GET_WITH_TOKEN('/api/moreblogs', '', res => {
            if (res?.blogs && Array.isArray(res.blogs)) {
                const formatted = res.blogs.map(post => ({ value: post.id, name: post.name }));
                setRelatedPostList(formatted);
            } else {
                setRelatedPostList([]);
            }
        }, err => console.log(err));
    };

    const validateForm = (formData) => {
        const newErrors = {};
        if (!formData.title?.trim()) newErrors.title = 'Title is required';
        if (!formData.slug?.trim()) newErrors.slug = 'Slug is required';
        if (!formData.package_category_id) newErrors.package_category_id = 'Package Category is required';
        if (!formData.category_id) newErrors.category_id = 'Category is required';
        if (!formData.sub_category_id) newErrors.sub_category_id = 'Sub Category is required';
        if (!formData.price || formData.price === 0) newErrors.price = 'Price is required';
        if (!formData.nights || formData.nights === 0) newErrors.nights = 'Nights is required';
        if (!formData.days || formData.days === 0) newErrors.days = 'Days is required';
        if (!formData.package_headline_first?.trim()) newErrors.package_headline_first = 'Package Headline First is required';
        if (!formData.package_headline_second?.trim()) newErrors.package_headline_second = 'Package Headline Second is required';
        if (!formData.total_person || formData.total_person === 0) newErrors.total_person = 'Total Person is required';
        if (!formData.accommodation?.trim()) newErrors.accommodation = 'Accommodation is required';
        if (!formData.overview?.getCurrentContent?.()?.getPlainText?.()?.trim()) newErrors.overview = 'Overview is required';
        if (!formData.inclusions?.getCurrentContent?.()?.getPlainText?.()?.trim()) newErrors.inclusions = 'Inclusions is required';
        if (!formData.exclusions?.getCurrentContent?.()?.getPlainText?.()?.trim()) newErrors.exclusions = 'Exclusions is required';
        if (!formData.travel_tips?.getCurrentContent?.()?.getPlainText?.()?.trim()) newErrors.travel_tips = 'Travel Tips is required';
        setErrors(newErrors);
        return newErrors;
    };

    const resetForm = () => {
        setIsEdit(false);
        setIsEditId('');
        setData(emptyForm);
        setFeaturedImageFile(null);
        setFeaturedImagePreview("");
        setItineraryFile(null);
        setSelectedIds([]);
        setSelectedName([]);
        setSelectedPosts([]);
        setSelectedPostIds([]);
        setQuestions([]);
        setPackageList([]);
        setErrors({});
    };

    // ✅ GetPackage uses direct fetch — no GET_WITH_TOKEN caching issues
    const GetPackage = async (id, subId, page = 1, title = searchRef.current) => {
        try {
            const token = localStorage.getItem("Token");
            const params = new URLSearchParams({
                category_id: id ?? "",
                sub_category_id: subId ?? "",
                page: String(page),
            });
            if (title && title.trim()) params.set("title", title.trim());
            const url = `${API_BASE}/api/packages/by-category?${params.toString()}`;
            console.log('Fetching:', url); // keep this to verify correct URL in console
            const response = await fetch(url, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Accept": "application/json",
                }
            });
            const json = await response.json();
            setBookingData(json?.data || []);
            setTotalPage(json?.last_page || 1);
            setCurrentPage(json?.current_page || page);
            currentPageRef.current = json?.current_page || page;
        } catch (err) {
            console.log('GetPackage error:', err);
        }
    };

    const Delete = (id) => {
        DELETS_WITH_TOKEN(`/api/packages/${id}`, '', success => {
            if (success) {
                showToast(success?.message || success?.msg || "Package deleted");
                // ✅ Use refs — guaranteed to have latest values
                GetPackage(CatIdRef.current, subCatIdRef.current, currentPageRef.current);
            }
        }, error => console.log(error), fail => console.log(fail));
    };

    const ShowById = (id) => {
        GET_WITH_TOKEN(`/api/packages/${id}`, "", success => {
            if (!success) return;

            const convertHtmlToEditorState = (html) => {
                if (!html) return EditorState.createEmpty();
                try {
                    const contentBlock = htmlToDraft(html);
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    return EditorState.createWithContent(contentState);
                } catch {
                    return EditorState.createEmpty();
                }
            };

            const pkg = success.data || success;
            const galleryImages = pkg.images || [];

            setData({
                ...emptyForm,
                ...pkg,
                overview: convertHtmlToEditorState(pkg.overview),
                inclusions: convertHtmlToEditorState(pkg.inclusions),
                exclusions: convertHtmlToEditorState(pkg.exclusions),
                travel_tips: convertHtmlToEditorState(pkg.travel_tips),
                brief_itinerary: convertHtmlToEditorState(pkg.brief_itinerary),
                highlights: convertHtmlToEditorState(pkg.highlights),
                terms_conditions: convertHtmlToEditorState(pkg.terms_conditions),
                seo_content: convertHtmlToEditorState(pkg.seo_content),
                images: Array.isArray(galleryImages)
                    ? galleryImages.map(img => ({
                        img_path: img.img_path,
                        img_txt: img.img_txt || "",
                        isnew: false
                    }))
                    : [],
            });

            setSelectedIds((pkg.linked_vector_images || []).map(r => r.id));
            setSelectedName(pkg.linked_vector_images || []);

            if (pkg.category_id) {
                getSubCat(pkg.category_id, false);
            }

            if (pkg.explore_blog) {
                const idsArray = pkg.explore_blog.split(',').map(id => Number(id.trim())).filter(Boolean);
                setSelectedPostIds(idsArray);
                const matchedPosts = relatedPostList.filter(item => idsArray.includes(item.value));
                setSelectedPosts(matchedPosts.map(item => ({ value: item.value, label: item.name })));
            } else {
                setSelectedPostIds([]);
                setSelectedPosts([]);
            }

            setFeaturedImageFile(null);
            setFeaturedImagePreview("");
            setItineraryFile(null);

            // Hydrate FAQ rows from the backend. Backend stores them as
            // {name, value, key}; the form works with {name, value}.
            const qk = Array.isArray(pkg.question_keys) ? pkg.question_keys : [];
            setQuestions(qk.map((r) => ({ name: r?.name || "", value: r?.value || "" })));
        }, error => console.log(error), fail => console.log(fail));
    };

    const AddPackageImages = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map(file => ({
            file,
            img_path: URL.createObjectURL(file),
            img_txt: "",
            isnew: true
        }));
        setData(prev => ({ ...prev, images: [...(prev.images || []), ...newImages] }));
    };

    const DeletePackageImage = (index) => {
        setData(prev => ({ ...prev, images: prev.images.filter((_, i) => i !== index) }));
    };

    const getCat = () => {
        GET_WITH_TOKEN(`/api/booking-categories`, "", success => {
            if (success) {
                const arr = success?.data?.data || success?.data || (Array.isArray(success) ? success : []);
                setPostList(arr);
            }
        }, err => console.log(err), fail => console.log(fail));
    };

    const getPackageCategory = () => {
        GET_WITH_TOKEN(`/api/package-categories`, "", success => {
            if (success) {
                const arr = success?.data?.data || success?.data || (Array.isArray(success) ? success : []);
                setPackage(arr);
            }
        }, err => console.log(err), fail => console.log(fail));
    };

    const getSubCat = (categoryId, resetSub = true) => {
        if (resetSub) {
            setData(prev => ({ ...prev, sub_category_id: "" }));
        }
        setPackageList([]);
        GET_WITH_TOKEN(`/api/booking-sub-categories/by-booking-id?booking_id=${categoryId}`, "", success => {
            if (success) {
                const arr = success?.data?.data || success?.data || (Array.isArray(success) ? success : []);
                setPackageList(arr);
            }
        }, err => console.log(err), fail => console.log(fail));
    };

    const getPostShow123 = () => {
        GET_WITH_TOKEN("/api/packages/vectorimages", "", onSuccess => {
            if (onSuccess) {
                const arr = onSuccess?.data?.data || onSuccess?.data || (Array.isArray(onSuccess) ? onSuccess : []);
                setVecotorImage(arr);
            }
        }, onFail => console.log(onFail), onError => console.error(onError));
    };

    const handleSelectionChange = (e) => {
        const selectedId = parseInt(e);
        if (!selectedIds.includes(selectedId)) {
            setSelectedIds(prev => [...prev, selectedId]);
        }
    };

    const handleRemove = (selectedList, removedItem) => {
        setSelectedIds(prev => prev.filter(id => id !== removedItem?.id));
    };

    const handleSubmit = async () => {
        const validationErrors = validateForm(Data);
        if (Object.keys(validationErrors).length > 0) return;

        const toHtml = (editorState) => {
            try {
                if (!editorState || typeof editorState.getCurrentContent !== 'function') return '';
                return draftToHtml(convertToRaw(editorState.getCurrentContent()));
            } catch { return ''; }
        };

        const token = localStorage.getItem("Token");
        if (!token) { showToast("No authentication token found"); return; }

        const formdata = new FormData();
        formdata.append("package_category_id", Data.package_category_id);
        formdata.append("category_id", Data.category_id);
        formdata.append("sub_category_id", Data.sub_category_id);
        formdata.append("title", Data.title);
        formdata.append("slug", Data.slug);
        formdata.append("duration", Data.duration || "");
        formdata.append("nights", Data.nights);
        formdata.append("days", Data.days);
        formdata.append("price", Data.price);
        formdata.append("price_unit", Data.price_unit || "");
        formdata.append("total_person", Data.total_person);
        formdata.append("pickup_drop", Data.pickup_drop || "");
        formdata.append("transportation", Data.transportation || "");
        formdata.append("meal_plan", Data.meal_plan || "");
        formdata.append("accommodation", Data.accommodation);
        formdata.append("overview", toHtml(Data.overview));
        formdata.append("inclusions", toHtml(Data.inclusions));
        formdata.append("exclusions", toHtml(Data.exclusions));
        formdata.append("travel_tips", toHtml(Data.travel_tips));
        formdata.append("brief_itinerary", toHtml(Data.brief_itinerary));
        formdata.append("highlights", toHtml(Data.highlights));
        formdata.append("terms_conditions", toHtml(Data.terms_conditions));
        formdata.append("seo_content", toHtml(Data.seo_content));
        formdata.append("rating", Data.rating || "");
        formdata.append("is_featured", "1");
        formdata.append("status", Data.status);
        formdata.append("type", Data.type || "");
        formdata.append("post_slug", Data.post_slug || "");
        formdata.append("package_headline_first", Data.package_headline_first || "");
        formdata.append("package_headline_second", Data.package_headline_second || "");
        formdata.append("title_one", Data.title_one || "");
        formdata.append("explore_blog", selectedPostIds.join(','));

        questions.forEach((q, i) => {
            formdata.append(`question_keys[${i}][key_name]`, q?.name || "");
            formdata.append(`question_keys[${i}][key_value]`, q?.value || "");
        });

        const newImages = Data.images.filter(img => img.isnew);
        const existingImages = Data.images.filter(img => !img.isnew);
        newImages.forEach(img => formdata.append('package_image[]', img.file));
        if (IsEdit) {
            existingImages.forEach(img => formdata.append('package_image-exist[]', img.img_path));
        }
        newImages.forEach(img => formdata.append('img_txt[]', img.img_txt || ""));
        existingImages.forEach(img => formdata.append('img_txt[]', img.img_txt || ""));
        if (featuredImageFile instanceof File) formdata.append("featured_image", featuredImageFile);
        // if (itineraryFile instanceof File) formdata.append("itinerary", itineraryFile); // Itinerary Document upload removed
        selectedIds.forEach(id => formdata.append("vector_image_ids[]", id));
        if (IsEdit) formdata.append('_method', 'PUT');

        try {
            const url = IsEdit
                ? `${API_BASE}/api/packages/${IsEditId}`
                : `${API_BASE}/api/packages`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
                },
                body: formdata
            });

            const result = await response.json();

            if (!response.ok || result?.success === false) {
                const firstError = result?.errors
                    ? Object.values(result.errors)[0]?.[0] || JSON.stringify(result.errors)
                    : result?.message || `HTTP ${response.status}`;
                throw new Error(firstError);
            }

            showToast(result?.message || (IsEdit ? "Package updated successfully!" : "Package created successfully!"));
            // ✅ Use refs — guaranteed latest values after async operation
            GetPackage(CatIdRef.current, subCatIdRef.current, currentPageRef.current);
            resetForm();

            const closeButton = document.querySelector('#offcanvasRight .btn-close');
            if (closeButton) closeButton.click();

        } catch (err) {
            console.error("Submit error:", err);
            showErrorToast("Error: " + (err?.message || "Something went wrong"));
        }
    };

    const StatusData = [
        { id: 1, name: "Active", value: 1 },
        { id: 0, name: "InActive", value: 0 }
    ];

    const TypeList = [
        { value: 0, id: 1, name: "Affordable packages" },
        { value: 1, id: 2, name: "Luxury packages" },
        { value: 2, id: 3, name: "Value packages" }
    ];

    return (
        <div>
            <div className='container mt-1'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='card'>
                            <div className='card-header'>
                                <p style={{ fontSize: '25px' }}>Package</p>

                                <CommanDropDown
                                    displayValue="Select Categories"
                                    value={CatId}
                                    title={"Pls Select"}
                                    desTitle={"Select Categories"}
                                    Data={PostList}
                                    onChange={(e) => {
                                        setCatId(e);
                                        CatIdRef.current = e;       // ✅ update ref
                                        setSubCatId('');
                                        subCatIdRef.current = '';   // ✅ update ref
                                        setCurrentPage(1);
                                        currentPageRef.current = 1; // ✅ update ref
                                        getSubCat(e, true);
                                    }}
                                />
                                <CommanDropDown
                                    displayValue="Select Sub Categories"
                                    value={subCatId}
                                    title={"Pls Select"}
                                    desTitle={"Select Sub Categories"}
                                    Data={packageList}
                                    onChange={(e) => {
                                        setSubCatId(e);
                                        subCatIdRef.current = e;    // ✅ update ref
                                        setCurrentPage(1);
                                        currentPageRef.current = 1; // ✅ update ref
                                        GetPackage(CatIdRef.current, e, 1);
                                    }}
                                />

                                <div className="mb-3 mt-4 d-flex">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Name"
                                        style={{ width: '20%' }}
                                        value={searchText}
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                            searchRef.current = e.target.value;
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                setCurrentPage(1);
                                                currentPageRef.current = 1;
                                                GetPackage(CatIdRef.current, subCatIdRef.current, 1, searchRef.current);
                                            }
                                        }}
                                    />
                                    <button type='button' className='ms-4'
                                        onClick={() => {
                                            setCurrentPage(1);
                                            currentPageRef.current = 1;
                                            GetPackage(CatIdRef.current, subCatIdRef.current, 1, searchRef.current);
                                        }}
                                        style={{ backgroundColor: '#008c93', color: '#fff', border: 'none', padding: '7px 15px', borderRadius: '8px' }}>
                                        Search
                                    </button>
                                    <button type='button' className='ms-2'
                                        onClick={() => {
                                            setSearchText("");
                                            searchRef.current = "";
                                            setCurrentPage(1);
                                            currentPageRef.current = 1;
                                            GetPackage(CatIdRef.current, subCatIdRef.current, 1, "");
                                        }}
                                        style={{ backgroundColor: 'transparent', color: '#000', padding: '7px 15px', borderRadius: '8px', border: '1px solid gray' }}>
                                        Reset
                                    </button>
                                    <button type='button' className='ms-2'
                                        data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                                        style={{ backgroundColor: '#366fe9', color: '#000', padding: '7px 15px', borderRadius: '8px', border: '1px solid gray' }}
                                        onClick={resetForm}>
                                        Add New
                                    </button>
                                </div>
                            </div>

                            <div className='card-body' style={{ height: 550, overflowY: "scroll" }}>
                                <p style={{ fontSize: '20px' }}>View All Package</p>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Price</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bookingData?.length > 0 ? bookingData.map((res, index) => (
                                            <tr key={res?.id}>
                                                <th scope="row">{((currentPage - 1) * 10) + index + 1}</th>
                                                <td>{res?.title}</td>
                                                <td>{res?.price}</td>
                                                <td>
                                                    <button className='py-2 mx-2'
                                                        style={{ backgroundColor: '#3cc3b0', color: '#fff', border: 'none', borderRadius: '4px' }}
                                                        data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                                                        onClick={() => { ShowById(res?.id); setIsEdit(true); setIsEditId(res?.id); setErrors({}); }}>
                                                        Edit
                                                    </button>
                                                    <button className='py-2 mx-2'
                                                        style={{ backgroundColor: '#2f6bff', color: '#fff', border: 'none', borderRadius: '4px' }}
                                                        onClick={() => window.open(`${API_BASE}/api/packages/${res?.id}/pdf`, '_blank')}>
                                                        PDF
                                                    </button>
                                                    <button className='py-2'
                                                        style={{ backgroundColor: '#9ba322', color: '#fff', border: 'none', borderRadius: '4px' }}
                                                        onClick={() => Delete(res?.id)}>
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        )) : null}
                                    </tbody>
                                </table>
                                {!bookingData?.length && (
                                    <div className="data-not-found">
                                        <h2 className="bounce">Data Not Found</h2>
                                        <p className="fade-in">Sorry, the requested data could not be found.</p>
                                    </div>
                                )}
                            </div>

                            {/* Plain numbered buttons — bypasses BasicPagination entirely */}
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", padding: "16px" }}>
                                <button
                                    disabled={currentPage === 1}
                                    onClick={() => {
                                        const p = currentPage - 1;
                                        setCurrentPage(p);
                                        currentPageRef.current = p;
                                        GetPackage(CatIdRef.current, subCatIdRef.current, p);
                                    }}
                                    style={{ padding: "6px 12px", borderRadius: "4px", border: "1px solid #008c93", backgroundColor: "#fff", color: "#008c93", cursor: currentPage === 1 ? "not-allowed" : "pointer", opacity: currentPage === 1 ? 0.5 : 1 }}
                                >
                                    Prev
                                </button>

                                {Array.from({ length: totalPage }, (_, i) => i + 1).map(p => (
                                    <button
                                        key={p}
                                        onClick={() => {
                                            setCurrentPage(p);
                                            currentPageRef.current = p;
                                            GetPackage(CatIdRef.current, subCatIdRef.current, p);
                                        }}
                                        style={{
                                            padding: "6px 14px",
                                            borderRadius: "4px",
                                            border: "1px solid #008c93",
                                            backgroundColor: p === currentPage ? "#008c93" : "#fff",
                                            color: p === currentPage ? "#fff" : "#008c93",
                                            cursor: "pointer",
                                            fontWeight: p === currentPage ? "bold" : "normal"
                                        }}
                                    >
                                        {p}
                                    </button>
                                ))}

                                <button
                                    disabled={currentPage === totalPage}
                                    onClick={() => {
                                        const p = currentPage + 1;
                                        setCurrentPage(p);
                                        currentPageRef.current = p;
                                        GetPackage(CatIdRef.current, subCatIdRef.current, p);
                                    }}
                                    style={{ padding: "6px 12px", borderRadius: "4px", border: "1px solid #008c93", backgroundColor: "#fff", color: "#008c93", cursor: currentPage === totalPage ? "not-allowed" : "pointer", opacity: currentPage === totalPage ? 0.5 : 1 }}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="offcanvas offcanvas-end"
                tabIndex="-1"
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
                data-bs-keyboard="false"
                style={{ width: '90%' }}
            >
                <div className="offcanvas-header">
                    <h5 id="offcanvasRightLabel">{IsEdit ? 'Update Package' : 'Add Package'}</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>

                <div className='offcanvas-body'>

                    <CommanInput value={Data.title} placeholder="Title" type="text" describtionShow={true} desTitle="Title"
                        onChange={e => setData({ ...Data, title: e })} />
                    {errors.title && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.title}</div>}

                    <CommanInput value={Data.slug} placeholder="Slug" type="text" describtionShow={true} desTitle="Slug"
                        onChange={e => setData({ ...Data, slug: e })} />
                    {errors.slug && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.slug}</div>}

                    <CommanInput value={Data.package_headline_first} placeholder="Package Headline First" type="text" describtionShow={true} desTitle="Package Headline First"
                        onChange={e => { setData({ ...Data, package_headline_first: e }); setErrors(p => ({ ...p, package_headline_first: '' })); }} />
                    {errors.package_headline_first && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.package_headline_first}</div>}

                    <CommanInput value={Data.package_headline_second} placeholder="Package Headline Second" type="text" describtionShow={true} desTitle="Package Headline Second"
                        onChange={e => { setData({ ...Data, package_headline_second: e }); setErrors(p => ({ ...p, package_headline_second: '' })); }} />
                    {errors.package_headline_second && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.package_headline_second}</div>}

                    <CommanInput value={Data.title_one} placeholder="Title One" type="text" describtionShow={true} desTitle="Title One"
                        onChange={e => setData({ ...Data, title_one: e })} />

                    <CommanDropDown displayValue="Package" value={Data.package_category_id} title="Pls Select" desTitle="Package Category" Data={Packlist}
                        onChange={e => setData({ ...Data, package_category_id: e })} />
                    {errors.package_category_id && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.package_category_id}</div>}

                    <CommanDropDown displayValue="category_id" value={Data.category_id} title="Pls Select" desTitle="Category" Data={PostList}
                        onChange={e => {
                            setData({ ...Data, category_id: e, sub_category_id: "" });
                            getSubCat(e, true);
                        }} />
                    {errors.category_id && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.category_id}</div>}

                    <CommanDropDown displayValue="sub_category_id" value={Data.sub_category_id} title="Pls Select" desTitle="Sub Category" Data={packageList}
                        onChange={e => setData({ ...Data, sub_category_id: e })} />
                    {errors.sub_category_id && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.sub_category_id}</div>}

                    <CommanInput value={Data.post_slug} placeholder="Blog Title" type="text" describtionShow={true} desTitle="Blog Title"
                        onChange={e => setData({ ...Data, post_slug: e })} />

                    <CommanInput value={Data.duration} placeholder="Duration" type="text" describtionShow={true} desTitle="Duration"
                        onChange={e => setData({ ...Data, duration: e })} />

                    <CommanInput value={Data.transportation} placeholder="Travel Medium" type="text" describtionShow={true} desTitle="Travel Medium"
                        onChange={e => setData({ ...Data, transportation: e })} />

                    <CommanInput value={Data.price} placeholder="Price" type="number" describtionShow={true} desTitle="Price"
                        onChange={e => setData({ ...Data, price: e })} />
                    {errors.price && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.price}</div>}

                    <CommanDropDown displayValue="Status" value={Data.status} title="Pls Select" desTitle="Status" Data={StatusData}
                        onChange={e => setData({ ...Data, status: e })} />

                    <CommanDropDown displayValue="Type" value={Data.type} title="Pls Select" desTitle="Type" Data={TypeList}
                        onChange={e => setData({ ...Data, type: e })} />

                    <CommanInput value={Data.nights} placeholder="Nights" type="number" describtionShow={true} desTitle="Nights"
                        onChange={e => setData({ ...Data, nights: e })} />
                    {errors.nights && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.nights}</div>}

                    <CommanInput value={Data.days} placeholder="Days" type="number" describtionShow={true} desTitle="Days"
                        onChange={e => setData({ ...Data, days: e })} />
                    {errors.days && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.days}</div>}

                    <CommanInput value={Data.pickup_drop} placeholder="Pickup Drop" type="text" describtionShow={true} desTitle="Pickup Drop"
                        onChange={e => setData({ ...Data, pickup_drop: e })} />

                    <CommanInput value={Data.price_unit} placeholder="Price Unit" type="text" describtionShow={true} desTitle="Price Unit"
                        onChange={e => setData({ ...Data, price_unit: e })} />

                    <CommanInput value={Data.total_person} placeholder="Total Person" type="number" describtionShow={true} desTitle="Total Person"
                        onChange={e => setData({ ...Data, total_person: e })} />
                    {errors.total_person && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.total_person}</div>}

                    <div className="mb-2 mt-3">
                        <label className="form-label" style={{ fontWeight: '600' }}>Meal Plan</label>
                        <select
                            className="form-select"
                            value={Data.meal_plan || ""}
                            onChange={e => setData({ ...Data, meal_plan: e.target.value })}
                        >
                            <option value="">— Select meal plan —</option>
                            <option value="EP">EP — No meals</option>
                            <option value="CP">CP — Breakfast only</option>
                            <option value="MAP">MAP — Breakfast + Dinner</option>
                            <option value="AP">AP — All meals</option>
                            {Data.meal_plan && !["EP", "CP", "MAP", "AP"].includes(Data.meal_plan) && (
                                <option value={Data.meal_plan}>{Data.meal_plan} (legacy — please re-select)</option>
                            )}
                        </select>
                    </div>

                    <CommanInput value={Data.accommodation} placeholder="Accommodation" type="text" describtionShow={true} desTitle="Accommodation"
                        onChange={e => setData({ ...Data, accommodation: e })} />
                    {errors.accommodation && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.accommodation}</div>}

                    <div className="mb-2">
                        <label className="form-label" style={{ fontWeight: '600' }}>Overview</label>
                        <div style={{ border: "1px solid gray" }}>
                            <Editor editorState={Data.overview} toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName"
                                onEditorStateChange={e => setData({ ...Data, overview: e })} />
                        </div>
                        {errors.overview && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.overview}</div>}
                    </div>

                    <div className="mb-2">
                        <label className="form-label" style={{ fontWeight: '600' }}>Brief Itinerary</label>
                        <div style={{ border: "1px solid gray" }}>
                            <Editor editorState={Data.brief_itinerary} toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName"
                                onEditorStateChange={e => setData({ ...Data, brief_itinerary: e })} />
                        </div>
                    </div>

                    <div className="mb-2">
                        <label className="form-label" style={{ fontWeight: '600' }}>Inclusions</label>
                        <div style={{ border: "1px solid gray" }}>
                            <Editor editorState={Data.inclusions} toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName"
                                onEditorStateChange={e => setData({ ...Data, inclusions: e })} />
                        </div>
                        {errors.inclusions && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.inclusions}</div>}
                    </div>

                    <div className="mb-2">
                        <label className="form-label" style={{ fontWeight: '600' }}>Exclusions</label>
                        <div style={{ border: "1px solid gray" }}>
                            <Editor editorState={Data.exclusions} toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName"
                                onEditorStateChange={e => setData({ ...Data, exclusions: e })} />
                        </div>
                        {errors.exclusions && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.exclusions}</div>}
                    </div>

                    <div className="mb-2">
                        <label className="form-label" style={{ fontWeight: '600' }}>Travel Tips</label>
                        <div style={{ border: "1px solid gray" }}>
                            <Editor editorState={Data.travel_tips} toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName"
                                onEditorStateChange={e => setData({ ...Data, travel_tips: e })} />
                        </div>
                        {errors.travel_tips && <div style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.travel_tips}</div>}
                    </div>

                    <div className="mb-2">
                        <label className="form-label" style={{ fontWeight: '600' }}>Highlights</label>
                        <div style={{ border: "1px solid gray" }}>
                            <Editor editorState={Data.highlights} toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName"
                                onEditorStateChange={e => setData({ ...Data, highlights: e })} />
                        </div>
                    </div>

                    <div className="mb-2">
                        <label className="form-label" style={{ fontWeight: '600' }}>Terms &amp; Conditions</label>
                        <div style={{ border: "1px solid gray" }}>
                            <Editor editorState={Data.terms_conditions} toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName"
                                onEditorStateChange={e => setData({ ...Data, terms_conditions: e })} />
                        </div>
                    </div>

                    <div className="mb-2">
                        <label className="form-label" style={{ fontWeight: '600' }}>SEO Content</label>
                        <small className="d-block text-muted mb-1">Long-form content for SEO. Shown at the bottom of the package detail page on the website.</small>
                        <div style={{ border: "1px solid gray" }}>
                            <Editor editorState={Data.seo_content} toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName"
                                onEditorStateChange={e => setData({ ...Data, seo_content: e })} />
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Explore Blog</label>
                        <Select
                            isMulti
                            options={relatedPostList.map(post => ({ value: post.value, label: post.name }))}
                            value={selectedPosts}
                            placeholder="Select blog posts..."
                            classNamePrefix="react-select"
                            onChange={(selected) => {
                                setSelectedPosts(selected || []);
                                setSelectedPostIds((selected || []).map(item => item.value));
                            }}
                            styles={{
                                control: (base) => ({ ...base, minHeight: 42, borderColor: "#dee2e6", boxShadow: "none" }),
                                multiValue: (base) => ({ ...base, backgroundColor: "#0d6efd" }),
                                multiValueLabel: (base) => ({ ...base, color: "#fff", fontSize: "13px" }),
                                multiValueRemove: (base) => ({ ...base, color: "#fff", cursor: "pointer", ":hover": { backgroundColor: "#0b5ed7" } })
                            }}
                        />
                    </div>

                    <CommanInput
                        placeholder="Package Images"
                        fileInput={true} input={false} textArea={false} multiple={true}
                        describtionShow={true} desTitle="Package Images (Multiple)"
                        onChange={AddPackageImages} accept="image/*"
                    />
                    <div className="row">
                        {Data.images?.map((item, index) => (
                            <div key={index} className="col-4 mb-3">
                                <div style={{ position: 'relative', display: 'inline-block' }}>
                                    <img src={item.img_path} alt={`preview-${index}`}
                                        style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd' }} />
                                    <button type="button" onClick={() => DeletePackageImage(index)}
                                        style={{ position: 'absolute', top: -5, right: 5, backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '50%', width: 25, height: 25, cursor: 'pointer', fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
                                </div>
                                <input type="text" className="form-control mt-2" placeholder="Image Text / Alt Text"
                                    value={item.img_txt || ""}
                                    onChange={(e) => {
                                        const updated = [...Data.images];
                                        updated[index].img_txt = e.target.value;
                                        setData({ ...Data, images: updated });
                                    }} />
                            </div>
                        ))}
                    </div>

                    <CommanInput value={Data.rating} placeholder="Rating" type="number" describtionShow={true} desTitle="Rating"
                        onChange={e => setData({ ...Data, rating: e })} />

                    <CommanDropDown
                        displayValue="key" useMultiselect={true} title="Pls Select" desTitle="Vector Image Ids"
                        Data={vecotorImage} slectedData={selectedName || []}
                        onRemove={handleRemove}
                        onChange={(e, name) => handleSelectionChange(e, name)}
                    />

                    <CommanInput type="file" fileInput={true} input={false} textArea={false}
                        describtionShow={true} desTitle="Featured Image" placeholder="Choose a file"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) { setFeaturedImagePreview(URL.createObjectURL(file)); setFeaturedImageFile(file); }
                        }} />
                    <div className='col-2'>
                        {(featuredImagePreview || Data.featured_image) && (
                            <img className="w-100" src={featuredImagePreview || Data.featured_image} alt="featured" style={{ width: 100 }} />
                        )}
                    </div>

                    {/* ===== Itinerary Document (file upload) — REMOVED, kept commented for future revive =====
                    <CommanInput type="file" fileInput={true} input={false} textArea={false}
                        describtionShow={true} desTitle="Itinerary Document" placeholder="Choose a file"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) { setData({ ...Data, itinerary: URL.createObjectURL(file), itineraryName: file.name }); setItineraryFile(file); }
                        }} />
                    <div className='col-2'>
                        {Data.itinerary && (
                            (Data.itineraryName && /\.pdf$/i.test(Data.itineraryName)) ||
                            (!Data.itineraryName && /\.pdf$/i.test(Data.itinerary))
                                ? (
                                    <a href={Data.itinerary} target="_blank" rel="noopener noreferrer">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg" alt="PDF" style={{ width: 100, height: 100 }} />
                                    </a>
                                ) : (
                                    <img className="w-100" src={Data.itinerary} alt="itinerary" style={{ width: 100 }} />
                                )
                        )}
                    </div>
                    ===== end Itinerary Document ===== */}

                    {/* ===== FAQ (Question / Answer) ===== */}
                    <div className='mt-3'>
                        <div
                            onClick={AddNewQuestion}
                            className='w-100 mt-2 mb-2 d-flex'
                            style={{ justifyContent: "flex-start", alignItems: "center", cursor: "pointer" }}
                        >
                            <div
                                style={{
                                    width: 30, height: 30, borderRadius: "50%",
                                    background: "#2563eb", color: "#fff", display: "flex",
                                    alignItems: "center", justifyContent: "center",
                                    fontSize: 22, fontWeight: 700, lineHeight: 1
                                }}
                            >+</div>
                            <h6 style={{ marginLeft: 16, color: "red", marginBottom: 0 }}>Add Faq Asked Questions</h6>
                        </div>

                        <div className='d-flex w-100 row'>
                            {questions.map((res, index) => (
                                <React.Fragment key={index}>
                                    <div className='col-5 p-2'>
                                        <label className="form-label" style={{ fontWeight: 600 }}>Question</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter Question"
                                            rows={3}
                                            value={res.name}
                                            onChange={(e) => {
                                                const next = [...questions];
                                                next[index] = { ...next[index], name: e.target.value };
                                                setQuestions(next);
                                            }}
                                        />
                                    </div>
                                    <div className='col-5 p-2'>
                                        <label className="form-label" style={{ fontWeight: 600 }}>Answer</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter Answer"
                                            rows={3}
                                            value={res.value}
                                            onChange={(e) => {
                                                const next = [...questions];
                                                next[index] = { ...next[index], value: e.target.value };
                                                setQuestions(next);
                                            }}
                                        />
                                    </div>
                                    <div className='col-2 p-2 d-flex align-items-center' style={{ marginTop: 30 }}>
                                        <Button variant="primary" onClick={() => DeleteQuestion(index)}>Delete</Button>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                    <Button className='mt-3' onClick={handleSubmit}>Submit</Button>
                </div>
            </div>
        </div>
    );
};

export default Package;
